import apiClient from './apiClient';
import { AIFillerRequest, AIFillerResponse } from '../types';

const apiBaseURL = '/ai-filler/';

/**
 * GenieFiller Service (formerly AI Helper)
 * AI-powered form filling — talks to /ai-filler/* backend routes.
 */
const aiFillerService = {
  async fillForm(request: AIFillerRequest): Promise<AIFillerResponse> {
    const response = await apiClient.post<AIFillerResponse>(`${apiBaseURL}fill-form`, request);
    return response.data;
  },
};

export default aiFillerService;
